import React, { useState } from "react";
import jsPDF from "jspdf";
import "jspdf-autotable";
import RequestV2 from "../../../api/RequestV2";
import { extractExportRows } from "./exportUtils";
import ExportToolbarButton from "./ExportToolbarButton";

/**
 * PDF export — V2 styling, RequestV2 only. Props match legacy PdfDown (useV2 ignored).
 * When `exportRows` is set, the PDF is built from that array (e.g. current table); no API call.
 */
export default function PdfDown({
  tableHeader,
  getTableBody,
  url,
  params,
  heading,
  fileName,
  width = 800,
  method = "post",
  type = "",
  useV2: _useV2,
  exportRows,
  disabled: disabledProp = false,
}) {
  const [isDisabled, setIsDisabled] = useState(false);

  const clientExport = exportRows !== undefined;
  const clientEmpty = clientExport && (!Array.isArray(exportRows) || exportRows.length === 0);

  const generatePDF = (tableBody) => {
    const doc = new jsPDF("l", "px", [width, 600]);

    if (heading) {
      doc.text(heading, doc.internal.pageSize.width / 2, 20, { align: "center" });
    }

    doc.autoTable({
      head: tableHeader,
      body: tableBody,
      startY: 25,
      styles: { overflow: "ellipsize", cellWidth: "wrap" },
      columnStyles: { text: { cellWidth: "auto" } },
    });

    doc.save((fileName || "document") + ".pdf");
  };

  const getUserList = () => {
    const successHandler = (res) => {
      const rows = extractExportRows(res, { method, useV2: true });
      if (rows.length > 0) {
        const tableBody = getTableBody(rows);
        generatePDF(tableBody);
      }
      setIsDisabled(false);
    };

    const errorHandler = () => {
      setIsDisabled(false);
    };

    const api = new RequestV2("", successHandler, errorHandler);
    if (method === "post") {
      api.post(url, params);
    } else {
      api.get(url);
    }
  };

  const handleClick = () => {
    if (isDisabled) return;
    if (clientExport) {
      setIsDisabled(true);
      const rows = Array.isArray(exportRows) ? exportRows : [];
      if (rows.length > 0) {
        const tableBody = getTableBody(rows);
        generatePDF(tableBody);
      }
      setIsDisabled(false);
      return;
    }
    setIsDisabled(true);
    getUserList();
  };

  const showButton = clientExport || url;
  const buttonDisabled = disabledProp || clientEmpty;

  return showButton ? (
    <ExportToolbarButton loading={isDisabled} disabled={buttonDisabled} onClick={handleClick}>
      PDF
    </ExportToolbarButton>
  ) : (
    <ExportToolbarButton disabled>
      PDF
    </ExportToolbarButton>
  );
}
